import { config, aboutUs } from "../utils";
import { mission, vision } from "../utils";

const AboutComp = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-4">
          <div className="container bg-light overflow-hidden px-lg-0">
            <div className="row g-0 mx-lg-0">
              <div
                className="col-lg-4 ps-lg-0 wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div className="position-relative h-100">
                  <img
                    className="position-absolute img-fluid w-100 h-90"
                    src="img/mission.jpg"
                    alt={"Mission"}
                  />
                </div>
              </div>
              <div
                className="col-lg-8 about-text py-1 wow fadeIn"
                data-wow-delay="0.5s"
              >
                <div className="p-lg-1 pe-lg-0">
                  <h1 className="text-primary">Our Mission</h1>
                  {mission.map((x, index) => {
                    return (
                      <p key={index} className="ms-2">
                        <i className="fa fa-check-circle text-primary me-3"></i>
                        {x}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutComp;
